import Vue from 'vue';
import { IQuote } from '@/models';

export default Vue.extend({
  name: 'QuoteLayoutMixin',

  methods: {
    useMachineLayout(quote: IQuote) {
      return quote.isMachineQuote() || quote.isAutomationQuote();
    }
  }
});
